import './selecttodropdown.scss';

class SelectToDropdownDirective {
    constructor($compile) {
        this.restrict = 'A';
        this.$compile = $compile;
        this.scope = {};

        this.uniqueId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
    }

    link(scope, element, attrs, controllers) {

        const options = [];
        let selected = null;

        for (const optionRaw of Array.prototype.slice.call(element.children())) {
            const $optionRaw = angular.element(optionRaw);
            const key = $optionRaw.prop('value');
            const value = $optionRaw.text();
            const optionObj = {key, value, raw: optionRaw};

            options.push(optionObj);

            if ($optionRaw.prop('selected')) {
                selected = optionObj;
            }
        }

        scope.options = options;
        scope.selected = selected;

        scope.select = (option) => {
            selected = option;
            scope.selected = option;
            element.val(option.key).triggerHandler("change");
        };

        const container = angular.element(`
        <div class="select-to-dropdown-container dropdown-container">
            <button type="button" dropdown target-id="select-to-dropdown-${this.uniqueId}" triggers="click">
                <span ng-if="selected">{{ selected.value }}</span>
                <span ng-if="!selected">Wybierz opcję</span>
                <svg width="15" height="15">
                    <use xlink:href="/templates/koga/dist/spritemap.svg#sprite-arrow-down"></use>
                </svg>
            </button>
            <ul class="dropdown right" id="select-to-dropdown-${this.uniqueId}">
                <li ng-repeat="option in options" ng-if="option != selected">
                    <button type="button" ng-click="select(option)">{{ option.value }}</button>
                </li>
            </ul>
        </div>`);
        element.parent().append(container);
        element.css({display: 'none'});

        this.$compile(container.children())(scope);

        scope.$on('$destroy', () => {
            element.css({display: 'inline-block'});
            container.remove();
        });
    }

    static directiveFactory($compile) {
        'ngInject';
        return new SelectToDropdownDirective($compile);
    }
}

export default SelectToDropdownDirective;